<template>
  <div>
    <v-row class="ma-0 pa-0">
      <v-col cols="12" align="Left" class="heading">
        Benefits You’ve Unlocked by becoming an Eblity Member
      </v-col>
      <v-col cols="12" class="sub-heading pt-0" align="Left">
        With Ebility, our goal is to make education for special children
        accessible, affordable by empowering educators like you.
      </v-col>
      <v-col
        class="py-0"
        cols="12"
        :style="$store.state.isMobile ? null : 'display: flex;'"
      >
        <div
          class="mr-8 mt-5 mt-md-0 bullet-text"
          v-for="(item, index) in bullets"
          :key="index"
        >
          <v-icon color="#506CFF" size="22" left>mdi-check-circle</v-icon>
          {{ item }}
        </div>
      </v-col>

      <v-row
        class="my-7"
        :align="$store.state.isMobile ? 'center' : null"
        :justify="$store.state.isMobile ? 'center' : null"
      >
        <v-col cols="11" md="6" v-for="(item, index) in items" :key="index">
          <v-card class="benifit-card" flat max-width="374px">
            <v-img
              max-height="212"
              width="100%"
              contain
              :src="item.image"
              class="benifit-img"
            />
            <v-card-text class="px-12">
              <div align="center" class="benifit-heading">
                {{ item.heading }}
              </div>
              <div class="my-3 benifit-sub-heading" align="center">
                ({{ item.sub_heading }})
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "MembershipThankYouBenefits",
    components: {},
    data() {
      return {
        trainingWorkshop: require("@/assets/membership/trainingWorkshop.svg"),
        expertWebinar: require("@/assets/membership/expertWebinar.svg"),
        learningResource: require("@/assets/membership/learningResource.svg"),
        studentSuccess: require("@/assets/membership/studentSuccess.svg"),
        guidedMentorship: require("@/assets/membership/guidedMentorship.svg"),
        exclusiveCommunity: require("@/assets/membership/exclusiveCommunity.svg"),
        bullets: ["Free Perks", "Exclusive Discounts", "Unlimited Access"],
      };
    },
    created() {},
    computed: {
      items() {
        return [
          {
            heading: "Unlimited Training Workshops",
            sub_heading: "Watch live or on-demand",
            image: this.trainingWorkshop,
          },
          {
            heading: "Unlimited Expert Webinars",
            sub_heading: "Upskill yourself constantly",
            image: this.expertWebinar,
          },
          {
            heading: "Unlimited Learning Resources",
            sub_heading: "Focus on ADHD, ASD, SLD & more",
            image: this.learningResource,
          },
          {
            heading: "Student Success App",
            sub_heading: "Manage Students Better",
            image: this.studentSuccess,
          },
          {
            heading: "Guided Mentorship",
            sub_heading: "Learning Paths & Guidance",
            image: this.guidedMentorship,
          },
          {
            heading: "Exclusive Community",
            sub_heading: "Curated Community of Educators",
            image: this.exclusiveCommunity,
          },
        ];
      },
    },
    watch: {},
    methods: {},
    mounted() {},
  };
</script>
<style scoped>
  .heading {
    font-weight: 900;
    font-size: 21px;
    line-height: 32px;
    color: #333333;
  }
  .sub-heading {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: rgba(51, 51, 51, 0.7);
  }
  .bullet-text {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: rgba(51, 51, 51, 0.7);
  }
  .benifit-card {
    border: 1px solid rgba(51, 51, 51, 0.38) !important;
    border-radius: 8px !important;
  }
  .benifit-img {
    background: #f2f2f2;
    border-radius: 27px 27px 0px 0px;
  }
  .benifit-heading {
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 25px;
    color: #506cff;
  }
  .benifit-sub-heading {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 20px;
    color: #333333;
  }
</style>
